import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { GoogleAuthProvider } from 'firebase/auth';
export const googleProvider = new GoogleAuthProvider();

const firebaseConfig = {
    apiKey: "AIzaSyDTi8XcpHzvr4aqJ-xlpoeWF2Ln47hEg_s",
    authDomain: "budget-app-ab331.firebaseapp.com",
    databaseURL: "https://budget-app-ab331-default-rtdb.firebaseio.com",
    projectId: "budget-app-ab331",
    storageBucket: "budget-app-ab331.firebasestorage.app",
    messagingSenderId: "26622353150",
    appId: "1:26622353150:web:9e8a4a229a6b5f35ea8faf"
  };

// Local development against the Firebase emulators instead of the live
// project: `REACT_APP_USE_EMULATORS=true npm start` (see scripts/dev-seed.mjs
// and the "Local development" section of the README). Off unless asked for, so
// there is no way to point production at a local database by accident.
export const usingEmulators =
  process.env.REACT_APP_USE_EMULATORS === 'true' && process.env.NODE_ENV !== 'production';

  // Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);

if (usingEmulators) {
  const host = process.env.REACT_APP_EMULATOR_HOST || 'localhost';
  connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
  connectDatabaseEmulator(database, host, 9000);
  connectStorageEmulator(storage, host, 9199);
  // Loud on purpose: every number on screen is fake in this mode.
  console.info(`[prisma-budget] using Firebase emulators on ${host} — this is seeded test data, not your account`);
}
